import i18n from 'i18next'
import translationPT from './translations/pt.json';
import translationES from './translations/es.json';

const resources = {
  pt: {
    translation: translationPT
  },
  es: {
    translation: translationES
  },
};

i18n
  .init({
    resources,
    fallbackLng: 'pt',
  });

export default i18n;